import { render } from "./TotalTwo.vue?vue&type=template&id=69cc4250&scoped=true"
const script = {}

import "./TotalTwo.vue?vue&type=style&index=0&id=69cc4250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cc4250"]])

export default __exports__